import { TimeSpanParam } from "./LeftArgumentTypes";

export class DelayTask {
    Delay: TimeSpanParam = new TimeSpanParam('00:00:00');
}

export class NotifyTask {
    /**
     * Message to be sent to the client
     * We can use here special variable patterns like {channelId:StateInterfaceName} to replace this with last state value, eq. {f945b230-cbb8-4dc0-ae0a-a85866467872_1:IChannelOnOff} will be replaced with 'on' or 'off' depending on the last state of the channel
     */
    Message: string = "";
    NotifyType: NotifyType = NotifyType.None;
    NotificationClients: string[] = [];
}

export enum NotifyType {
    None = 0,
    AppNotification = 1,
    Email = 2
}
  
export class LockExecutionTask {
    LockType: LockType = LockType.Timeout;
    LockStartHour: TimeSpanParam = new TimeSpanParam("00:00:00");
    LockEndHour: TimeSpanParam = new TimeSpanParam("00:00:00");
    ResetLockScenesGuids: string[] = [];
}

export enum LockType {
    Timeout = 0,
    TimeRange = 1
}